import Navbar from "./Navbar";

function Layout({ children }) {
    return (
        <div style={styles.page}>
            <Navbar />
            <div style={styles.content}>{children}</div>
        </div>
    );
}

const styles = {
    page: {
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        background:
            "linear-gradient(111.1deg, rgb(0,40,70) -4.8%, rgb(255,229,115) 82.7%, rgb(255,203,15) 97.2%)",
    },
    content: {
        width: "100%"
    },
};

export default Layout;